import React, { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { FORM_FIELDS_MAP } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.constants';
import moment from 'moment';
import strings from 'strings';
import CustomDatePicker from 'UI/components/atoms/CustomDatePicker';
import { REQUIRED_VALIDATION } from 'UI/utils';

import { DEFAULT_TIME_PICKER_PROPS } from '../constants';
import { TimezoneSelector } from '../TimezoneSelector';

const validateTimeRange = ({ value, getValues }) => {
  const requiredMessage = REQUIRED_VALIDATION.required;

  if (!value) {
    return requiredMessage;
  }

  const formValues = getValues();
  const fromHour = formValues[FORM_FIELDS_MAP.InterviewFromHour.key];
  const toHour = formValues[FORM_FIELDS_MAP.InterviewToHour.key];

  if (fromHour && toHour) {
    const fromMoment = moment(fromHour, 'HH:mm:ss');
    const toMoment = moment(toHour, 'HH:mm:ss');

    const isFromAfterOrEqualTo = fromMoment.isSameOrAfter(toMoment);

    if (isFromAfterOrEqualTo) {
      return strings.sendouts.form.errors.invalidTimeRange;
    }
  }

  return true;
};

export const TimeRangeFields = () => {
  const { control, errors, getValues, triggerValidation } = useFormContext();

  const handleTimeChange = useCallback(
    ([, value]) => {
      triggerValidation([
        FORM_FIELDS_MAP.InterviewFromHour.key,
        FORM_FIELDS_MAP.InterviewToHour.key
      ]);
      return value ? moment(value) : null;
    },
    [triggerValidation]
  );

  return (
    <>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewFromHour.key}
          control={control}
          rules={{
            ...REQUIRED_VALIDATION,
            validate: value => validateTimeRange({ value, getValues })
          }}
          defaultValue={null}
          as={
            <CustomDatePicker
              disablePast
              isClearable
              error={!!errors[FORM_FIELDS_MAP.InterviewFromHour.key]}
              helperText={errors[FORM_FIELDS_MAP.InterviewFromHour.key]?.message}
              label={strings.sendouts.form.labels.fromHour}
              name={FORM_FIELDS_MAP.InterviewFromHour.key}
              variant="keyboardTime"
              withTime
              {...DEFAULT_TIME_PICKER_PROPS}
            />
          }
          onChange={handleTimeChange}
          onChangeName="onDateChange"
          valueName="value"
        />
      </Grid>
      <Grid item xs={6}>
        <Controller
          name={FORM_FIELDS_MAP.InterviewToHour.key}
          control={control}
          rules={{
            ...REQUIRED_VALIDATION,
            validate: value => validateTimeRange({ value, getValues })
          }}
          defaultValue={null}
          as={
            <CustomDatePicker
              disablePast
              isClearable
              error={!!errors[FORM_FIELDS_MAP.InterviewToHour.key]}
              helperText={errors[FORM_FIELDS_MAP.InterviewToHour.key]?.message}
              label={strings.sendouts.form.labels.toHour}
              name={FORM_FIELDS_MAP.InterviewToHour.key}
              variant="keyboardTime"
              withTime
              {...DEFAULT_TIME_PICKER_PROPS}
            />
          }
          onChange={handleTimeChange}
          onChangeName="onDateChange"
          valueName="value"
        />
      </Grid>
      <Grid item xs={12}>
        <TimezoneSelector />
      </Grid>
    </>
  );
};
